<template>
  <li class="menu-item">
    <component
      :is="to ? 'router-link' : 'a'"
      :target="newTab ? '_blank' : '_self'"
      :rel="newTab ? 'noopener' : undefined"
      :href="href"
      :to="to"
      :data-testid="dataTestid || getDataTestId(props.title || '')"
      class="cursor-pointer group"
      @click="handleClick"
      :class="[
        getItemClass({
          disabled: disabled,
          type: type,
        }),
        hoverableTitle ? 'w-max hover:shadow-lg z-10 relative' : '',
      ]"
    >
      <span class="flex items-center gap-2">
        <span v-if="icon || loading" class="relative flex">
          <Icon v-if="icon && !loading" :name="icon" size="base" class="menu-icon" />
          <Icon v-if="loading" name="general.spinner" size="base" class="menu-icon" />
          <span v-if="dotType && hoverableTitle" class="dot-indicator"></span>
        </span>
        <span :class="[hoverableTitle ? 'hidden group-hover:inline-flex' : 'inline-flex w-full']" class="truncate max-w-[40ch] items-center gap-1">
          <slot />
        </span>
        <span v-if="$slots.subtitle" class="block font-normal text-slate-600">
          <slot name="subtitle" />
        </span>
      </span>
      <span>
        <BetaBadge v-if="isBeta" size="large" />
        <NewBadge v-else-if="isNew" size="large" />
      </span>
    </component>
  </li>
</template>

<script setup lang="ts">
import { getItemClass, getDataTestId } from './ItemsHelper';
import { Icon } from './../../icon';
import { BetaBadge } from './../../utilities';
import { NewBadge } from './../../utilities';
import { RouteLocationRaw } from 'vue-router';

export interface MenuItem {
  title?: string;
  href?: string;
  to?: RouteLocationRaw;
  dataTestid?: string;
  icon?: string;
  newTab?: boolean;
  disabled?: boolean;
  loading?: boolean;
  type?: string;
  hoverableTitle?: boolean;
  isBeta?: boolean;
  isNew?: boolean;
  dotType?: string;
}

const props = defineProps<MenuItem>();
const emit = defineEmits(['click']);
const handleClick = (event: MouseEvent) => {
  if (props.disabled) {
    event.preventDefault();
    return;
  }
  emit('click', event);
};
</script>
<style>
.dot-indicator {
  @apply absolute -right-1 -top-1 h-[7px] w-[7px] rounded-full bg-[#007AFF];
}
</style>
